import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/main.css'
import Vueform from '@vueform/vueform'
import vueformConfig from '../vueform.config'
import { useAuthStore } from './stores/auth'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(Vueform, vueformConfig)
app.use(router)

// Initialize authentication before mounting app
// This handles cross-subdomain scenarios where cookies exist but localStorage is empty
try {
  const authStore = useAuthStore()
  authStore.initAuth().then(() => {
    app.mount('#app')
  }).catch((error) => {
    // Don't prevent app from mounting if auth initialization fails
    console.error('Auth initialization error:', error)
    app.mount('#app')
  })
} catch (error) {
  // Don't prevent app from mounting if auth initialization fails
  console.error('Auth initialization error:', error)
  app.mount('#app')
}